import axios from "axios"

const axiosAPI = axios.create({
    baseURL: `${import.meta.env.VITE_API_URL}`,
    timeout: 10000,
    withCredentials: false
})

axiosAPI.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem("token")
        if (config.url?.includes('/upload-image') || config.url?.includes("/upload-profile") || config.url?.includes("/upload-thumbnail")) {
            config.headers['Content-Type'] = 'multipart/form-data';
        } else {
            config.headers['Content-Type'] = 'application/json'; // Default for other requests
        }

        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`
        } else if (config.headers) {
            delete config.headers.Authorization
        }

        return config;
    },
    (error) => Promise.reject(error)
);


axiosAPI.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.log("Unauthorized - redirect to login page");
            localStorage.removeItem("token");
            window.location.href = "/";
        }

        return Promise.reject(error)
    }
);

export default axiosAPI